import { FormDescription, FormItem, FormLabel } from '@/components/shadcn/form'
import { Button } from '@/components/shadcn/button'
import { BaseFieldProps } from './types'
import clsx from 'clsx'
import { DocumentationButton } from './DocumentationButton'

export const UriField: React.FC<BaseFieldProps> = ({ field }) => {
  return (
    <FormItem className={clsx('flex flex-1 flex-col', field.widget === 'hidden' && 'hidden')}>
      <div className="flex justify-start gap-2">
        <FormLabel>{field.title}</FormLabel>
        <DocumentationButton documentation={field.documentation} />
      </div>
      <FormDescription className="text-xs">{field.description}</FormDescription>
      <Button
        type="button"
        variant="outline"
        onClick={() => {
          if (field.default) {
            window.open(field.default, '_blank')
          }
        }}
        disabled={field.readOnly}
      >
        Download
      </Button>
    </FormItem>
  )
}
